<template>
  <div class="platform-page">
    <section class="platform-hero">
      <img :src="platformBannerImage" alt="全球领先多元化云服务平台">
    </section>

    <section class="platform-entry-section">
      <div class="container platform-entry-grid">
        <article class="platform-entry-card web">
          <img src="@/assets/image/web.png" alt="">
          <div>
            <span>后端管理系统</span>
            <a href="https://www.gps666.net" target="_blank" rel="noopener">www.gps666.net</a>
          </div>
        </article>
        <article class="platform-entry-card">
          <img src="@/assets/image/android.png" alt="">
          <div>
            <span>Qianxun</span>
            <strong>Andriod</strong>
          </div>
          <img class="entry-qrcode" src="@/assets/image/all.png" alt="安卓二维码">
        </article>
        <article class="platform-entry-card">
          <img src="@/assets/image/ios.png" alt="">
          <div>
            <span>Qianxun</span>
            <strong>IOS</strong>
          </div>
          <img class="entry-qrcode" src="@/assets/image/all.png" alt="IOS二维码">
        </article>
        <article class="platform-entry-card">
          <img src="@/assets/image/wx.png" alt="">
          <div>
            <span>Qianxun</span>
            <strong>小程序</strong>
          </div>
          <img class="entry-qrcode" src="@/assets/image/applet.png" alt="小程序二维码">
        </article>
      </div>
    </section>

    <section id="intro" class="platform-intro-section">
      <div class="container">
        <div class="platform-title">
          <h2>平台介绍</h2>
          <span>QIANXUN PLATFORM</span>
        </div>
        <p class="platform-intro-text">
          深圳市千讯云创科技有限公司致力于打造全球领先的多元化云服务平台。我们的平台以技术创新为核心，旨在快速接入车载智能终端、资产管理终端、个人安全终端、动物安全终端等多样化设备，构建从硬件到云端的一体化通信链路。通过强大的云端协同能力，平台实现了设备数据的实时采集、精准识别、智能分析与可视化呈现，形成“端-云-用”全链路闭环。
        </p>
        <div class="platform-feature-grid">
          <article v-for="item in platformFeatures" :key="item.title" class="platform-feature">
            <img :src="item.icon" :alt="item.title">
            <h3>{{ item.title }}</h3>
          </article>
        </div>
      </div>
    </section>

    <section id="strength" class="platform-strength-section">
      <div class="container">
        <div class="platform-title">
          <h2>平台实力</h2>
          <span>PLATFORM STRENGTH</span>
        </div>
        <div class="strength-stats">
          <div v-for="item in strengthStats" :key="item.label">
            <strong>{{ item.value }}<small>{{ item.unit }}</small></strong>
            <span>{{ item.label }}</span>
          </div>
        </div>
      </div>
    </section>

    <section class="strength-card-section">
      <div class="strength-card-grid">
        <article v-for="item in strengthCards" :key="item.title" class="strength-card">
          <img :src="item.icon" :alt="item.title">
          <h3>{{ item.title }}</h3>
          <p>{{ item.desc }}</p>
        </article>
      </div>
    </section>

    <section id="private" class="private-section">
      <div class="container">
        <div class="platform-title">
          <h2>私人定制专属平台</h2>
          <span>EXCLUSIVE PLATFORM</span>
        </div>
        <p>
          千讯云创与多家名企达成合作，量身化定制一体解决方案，提供差异化风控模式构建的专业指导，助力企业降本增效。打造企业的专属平台私人定制域名、logo、主页、APP、后台系统等。
        </p>
        <img :src="privateBgImage" alt="私人定制专属平台">
      </div>
    </section>

    <section id="team" class="platform-team-section">
      <div class="container">
        <div class="platform-title">
          <h2>专业的研发团队</h2>
          <span>EXCLUSIVE PLATFORM</span>
        </div>
        <p>
          千讯云创拥有研发人员近40余人，包含物联网行业资深人才、中南大学硕士、国内知名大学本科及专科以上学历，集合服务器部署、IOS/安卓/鸿蒙APP开发、WEB端/小程序开发、GPS硬件开发、嵌入式软件开发、结构工程师、软硬件测试工程师等物联网领域专业人才，为全球客户提供整体的动态物联网解决方案。
        </p>
        <img src="@/assets/image/personnel.png" alt="专业的研发团队">
      </div>
    </section>
  </div>
</template>

<script>
import { getStoredLanguage } from '../i18n/localLanguage'

export default {
  name: 'NewsView',
  data() {
    return {
      currentLanguage: getStoredLanguage(),
      platformFeatures: [
        { title: '多级管理', icon: require('@/assets/image/platform1.png') },
        { title: '私人定制', icon: require('@/assets/image/platform2.png') },
        { title: 'SaaS化场景服务', icon: require('@/assets/image/platform3.png') },
        { title: '大数据分析', icon: require('@/assets/image/platform4.png') }
      ],
      strengthStats: [
        { value: '1300', unit: '万+', label: '全球设备连接数' },
        { value: '8000', unit: '万+', label: '日均活跃用户' },
        { value: '170', unit: '+', label: '覆盖国家和地区' },
        { value: '100', unit: '万亿+', label: '累计处理位置服务数据' }
      ],
      strengthCards: [
        { title: '军工级数据安全防护', icon: require('@/assets/image/strength1.png'), desc: '云原生架构与多层加密技术，通过国密算法认证及隐私数据脱敏处理，确保用户数据零泄露。' },
        { title: '全域高稳定信号覆盖', icon: require('@/assets/image/strength2.png'), desc: '采用多模融合定位技术（GPS/北斗/LBS等）与智能信号增强算法，全球范围无缝衔接，保障设备实时在线。' },
        { title: '开放的接入能力', icon: require('@/assets/image/strength3.png'), desc: '基于AI进行架构的高性能网关，开放式API/OTA，支持多种协议可轻松对接第三方厂家设备及平台。' },
        { title: '全场景智能兼容能力', icon: require('@/assets/image/strength4.png'), desc: '开放标准化API与SDK工具链，兼容车载、资产、个人及动物安全等200+类终端协议。' }
      ]
    }
  },
  computed: {
    platformBannerImage() {
      return this.currentLanguage === 'en'
        ? require('@/assets/image/platform_banner_en.png')
        : require('@/assets/image/platform_banner.png')
    },
    privateBgImage() {
      return this.currentLanguage === 'en'
        ? require('@/assets/image/private_bg_en.png')
        : require('@/assets/image/private_bg.png')
    }
  },
  mounted() {
    window.addEventListener('site-language-change', this.syncLanguage)
  },
  beforeDestroy() {
    window.removeEventListener('site-language-change', this.syncLanguage)
  },
  methods: {
    syncLanguage(event) {
      this.currentLanguage = event.detail || getStoredLanguage()
    }
  }
}
</script>
